import { useState, useEffect, useRef } from 'react';

export default function useCountdown(initialMilliseconds: number, callback?: () => void) {
	const [secondsRemaining, setSecondsRemaining] = useState(Math.floor(initialMilliseconds / 1000));

	const timer = useRef<any>(null)

	useEffect(() => {
		if (secondsRemaining <= 0) {
			if (secondsRemaining < 0) {
				callback?.();
			} else {
				setSecondsRemaining(0)
			}
			return;
		}
		clearInterval(timer.current);
		timer.current = setInterval(() => {
			setSecondsRemaining((prev) => {
				if (prev <= 1) {
					clearInterval(timer.current);
					callback?.();
					setSecondsRemaining(0)
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer.current);
	}, [secondsRemaining]);

	const formatTime = (seconds: number) => {
		if (seconds >= 3600) {
			const hours = Math.floor(seconds / 3600);
			const mins = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;
			return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
		}
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
	};

	return {
		secondsRemaining,
		startCountdown: () => formatTime(secondsRemaining),
		stopCountdown: () => setSecondsRemaining(0),
	};
}